import React from 'react';
import TestimonialsTemplate from "../../../common/components/TestimonialsTemplate";
import useTranslation from "next-translate/useTranslation";
import {RF_NAMESPACE} from "../../../../utils/i18nNameSpaces";

const Testimonial = ({testimonials = null}) => {
  const {t} = useTranslation(RF_NAMESPACE);

  return (
    <>
      {testimonials &&
        <TestimonialsTemplate testimonials={testimonials.testimonials}
                              namespace={RF_NAMESPACE}/>}
    </>
  );
};

export default Testimonial;
